export default "__VITE_ASSET__DXqSfZlf__"